import { creditCardDetails } from './credit-card-details';

// const limitAccountNumber = useCallback(
//   () => localStorage.getItem('limitAccountNumber') ?? (10 as any),
//   [localStorage.getItem('limitAccountNumber')],
// );

const handleInputOnInput: (e: any) => void = e => {
  if (e.target.maxLength > 0 && e.target.value.length > e.target.maxLength) {
    e.target.value = e.target.value.slice(0, e.target.maxLength);
  }
};
const handleInputOnKeydown: (e: any) => void = e => {
  ['ArrowDown', 'ArrowUp', 'KeyE'].includes(e.code) && e.preventDefault();
};

const formatExpiryDate = (event: any) => {
  const input = event.target;
  let value = input.value.replace(/\D/g, ''); // Remove non-numeric characters
  const month = value.slice(0, 2);
  const year = value.slice(2, 4);

  if (month.length > 0) {
    value = month;
    if (month.length === 2 && value[value.length - 1] !== '/') {
      value += '/';
    }
  }

  if (year.length > 0) {
    value += year;
  }

  input.value = value;
};

const formatOptCode = (event: any) => {
  const input = event.target;
  let value = input.value.replace(/\D/g, ''); // Remove non-numeric characters
  value = `GW-${value.slice(0, 6)}`;
  input.value = value;
};

const formatdateOfBirth = (event: any) => {
  const input = event.target;
  let value = input.value.replace(/\D/g, ''); // Remove non-numeric characters
  const year = value.slice(0, 4);
  const month = value.slice(4, 6);
  const day = value.slice(6, 8);

  if (year.length > 0) {
    value = year;
    if (month.length > 0) {
      const monthNumber = parseInt(month, 10);
      if (monthNumber > 12) {
        value = year;
      } else {
        value += `-${month}`;
        if (day.length > 0) {
          const dayNumber = parseInt(day, 10);
          if (dayNumber > 31) {
            value = `${year}-${month}`;
          } else {
            value += `-${day}`;
          }
        }
      }
    }
  }

  input.value = value;
};

const formatCardNumber = (event: any) => {
  const input = event.target;
  const value: string = input.value.replace(/\D/g, ''); // Remove non-numeric characters

  const { type, gaps } = creditCardDetails(value);

  if (type && gaps) {
    const offsetsArray: Array<number> = [];
    const offsets = offsetsArray.concat(0, gaps, value.length);
    const components = [];

    for (let i = 0; offsets[i] < value.length; i++) {
      const start = offsets[i];
      const end = Math.min(offsets[i + 1], value.length);
      components.push(value.substring(start, end));
    }
    input.value = components.join(' ');
    return;
  }

  input.value = value;
};

const formatNumberAuthorizeByCountry = (event: any) => {
  const indicatif = localStorage.getItem('countrySelectedOne');
  const input = event.target;
  let value = input.value.replace(/\D/g, ''); // Supprimer les caractères non numériques

  // Longueur maximale par défaut
  let maxLength = 8; // Par défaut pour le Tchad et la RCA

  if (indicatif) {
    // Définir la longueur maximale en fonction de l'indicatif
    switch (indicatif) {
      case '235': // Tchad
        maxLength = 8; // 8 chiffres après l'indicatif
        break;
      case '237': // Cameroun
        maxLength = 9; // 9 chiffres après l'indicatif
        break;
      case '241': // Gabon
        maxLength = 9; // 9 chiffres après l'indicatif
        break;
      case '242': // Congo
        maxLength = 9; // 9 chiffres après l'indicatif
        break;
      case '236': // RCA
        maxLength = 8; // 8 chiffres après l'indicatif
        break;
      default:
        maxLength = 9; // Valeur par défaut si l'indicatif est inconnu
        break;
    }

    // Supprimer les chiffres de l'indicatif s'ils sont déjà présents dans la valeur
    if (value.startsWith(indicatif)) {
      value = value.slice(indicatif.length);
    }
  }

  // Appliquer la limite de longueur
  value = value.slice(0, maxLength);

  // Ré-appliquer l'indicatif si nécessaire
  input.value = value;
};

export {
  formatCardNumber,
  formatdateOfBirth,
  formatExpiryDate,
  formatNumberAuthorizeByCountry,
  formatOptCode,
  handleInputOnInput,
  handleInputOnKeydown,
};
